<template>
  <ul v-if="type === 1">
    <li>
      本券为麦当劳麦乐送包邮套餐券，仅限在麦当劳APP,
      麦当劳微信小程序，麦当劳支付宝小程序下单外卖配送使用，请认真核对充值兑换的手机号并在兑换码有效期内兑换，兑换码过期将无法使用，不退换不补偿。
    </li>
    <li>本套餐包含邮费，不含餐具费。</li>
    <li>
      购买后，客户用充值兑换的手机号登陆麦当劳APP，“麦当劳”微信小程序或者“麦当劳”支付宝小程序，点击“我的”-“外送券”页面，查看本券;
    </li>
    <li>
      使用方式：请于点餐时在微信麦当劳APP，“麦当劳”微信小程序或者“麦当劳”支付宝小程序的麦乐送下单使用本券，本券单笔订单限用1张，不可与其它产品券叠加使用。
    </li>
    <li>
      权益截止使用时间：自兑换充值到麦当劳账户之日起14天内有效，到期未使用不退不补，请在有效期内尽快使用。
    </li>
    <li>
      卡券为不记名卡，仅可一次性核销，不可办理挂失、不兑换现金或找零、不可透支、不可充值。
    </li>
    <li>
      使用范围：本券仅限于大陆地区除吉林、安徽、甘肃、青岛、黑龙江、河南、内蒙古、重庆、广西、贵州、江西、云南、新疆、西藏、中山、珠海外的部分麦当劳餐厅，
      并限于该食品的供应时段内使用，具体以店内公示为准，机场、火车站等交通枢纽餐厅、旅游景区餐厅等特殊餐厅除外。餐厅营业时间以门店实际为准。
    </li>
  </ul>
  <ul v-else>
    <li>
      请详细核对兑换手机号，必须是11位数正确手机号码。兑换成功后无法更换和退款，因个人原因导致兑换手机号错误，本平台概不负责。
    </li>
    <li>请在有效期内使用，过期将无法使用，不退换不补偿。</li>
    <li>兑换可能会存在延迟情况，正常30分钟内发放完成。</li>
    <li v-if="textReplace">若30分钟未发放完成，请联系活动主办方。</li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      textReplace: Number(this.$route.query.t) === 1,
      type: Number(this.$route.query.type)
    }
  }
}
</script>
